var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwoWayArrowsHorizontal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.299,
    height: 6.408,
    viewBox: "0 0 18.299 6.408",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-555.379 -2516.251)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(556 2516.251)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 16.624,
    transform: "translate(0 3.209)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-242.887,128.766",
    transform: "translate(246.45 -128.766)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.521,
    x2: 4.641,
    transform: "translate(0.057 0.688)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.641,
    y1: 2.521,
    transform: "translate(0.057 3.209)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.641,
    y2: 2.521,
    transform: "translate(12.359 3.209)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 4.641,
    y2: 2.521,
    transform: "translate(12.359 0.688)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwoWayArrowsHorizontal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/two-way-arrows-horizontal.dc7597f3.svg";
export { ForwardRef as ReactComponent };